import React, { type ReactNode } from 'react'
import { Card } from 'antd'

export interface SupportStatsKpiCardProps {
  /** Primary line (e.g. "Added Institutions", "Provided") */
  title: string
  /** Secondary line — shown smaller under the title (e.g. "Total count", "Bid guarantees") */
  category: string
  value: number | string
  icon: ReactNode
  /** Accent for top bar, icon tint, and figure */
  accent: string
}

/**
 * Compact KPI tile for support / institution overview stats (institutions, guarantees, checks).
 */
const SupportStatsKpiCard: React.FC<SupportStatsKpiCardProps> = ({
  title,
  category,
  value,
  icon,
  accent
}) => {
  return (
    <Card
      bordered={false}
      hoverable
      className="support-stats-kpi-card h-full"
      bodyStyle={{
        padding: '18px 18px 20px'
      }}
      style={{
        width: '100%',
        borderRadius: 14,
        border: '1px solid rgba(15, 23, 42, 0.06)',
        borderTop: `3px solid ${accent}`,
        background: 'linear-gradient(165deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)',
        boxShadow:
          '0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px -6px rgba(15, 23, 42, 0.09)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 14
        }}
      >
        <div
          aria-hidden
          style={{
            flexShrink: 0,
            width: 52,
            height: 52,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `linear-gradient(145deg, ${accent}22, ${accent}0d)`,
            border: `1px solid ${accent}40`,
            color: accent,
            fontSize: 24
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: '#0f172a',
              lineHeight: 1.35,
              marginBottom: 4
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: '#64748b',
              marginBottom: 8
            }}
          >
            {category}
          </div>
          <div
            style={{
              color: accent,
              fontSize: 26,
              fontWeight: 700,
              letterSpacing: '-0.02em',
              lineHeight: 1.15
            }}
          >
            {value}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default SupportStatsKpiCard
